import { Injectable } from "@angular/core";
import {Storage} from "@ionic/storage";
import {ReplaySubject} from "rxjs/ReplaySubject";

const ROLE_STORAGE_KEY = 'tolkify_app_role';


@Injectable()
export class RoleService {

  private roleState$: ReplaySubject<string> = new ReplaySubject<string>(1);  // interpreter|organisation

  constructor(private storage: Storage) {}

  init(){
    return this.storage.get(ROLE_STORAGE_KEY)
      .then((role) => this.roleState$.next(role));
  }

  getRole(){
    return this.roleState$;
  }

  setRole(role){
    return this.storage.set(ROLE_STORAGE_KEY, role)
      .then(() => this.roleState$.next(role));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/role.service.ts